// Summed hours carry float noise (39.99999999999999), so round to the stored two decimals.
export const roundHours = (hours: number) => Math.round(hours * 100) / 100;

export const formatHours = (hours: number) => String(roundHours(hours));
